import React from 'react';
import { useTranslation } from 'react-i18next';
import { Send, Loader2 } from 'lucide-react';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../../ui/dialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  recipients: number;
  loading: boolean;
  onConfirm: () => void;
  onLater: () => void;
}

/**
 * Prévenir les participants d'un changement d'horaire.
 *
 * Découplé du réordonnancement lui-même : déplacer un heat déjà publié
 * envoyait auparavant les emails sans demander (fuite constatée en prod,
 * corrigée le 2026-07-03). « Plus tard » est un choix légitime, pas une
 * annulation du déplacement.
 */
const ScheduleNotifyDialog: React.FC<Props> = ({
  open, onOpenChange, recipients, loading, onConfirm, onLater,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {t('heats.scheduleNotify.title')}
          </DialogTitle>
        </DialogHeader>

        <div className="py-2">
          <p className="text-sm text-muted-foreground">
            {t('heats.scheduleNotify.intro', { count: recipients })}
          </p>
          <p className="text-xs text-muted-foreground mt-2">{t('heats.scheduleNotify.hint')}</p>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onLater}>
            {t('heats.scheduleNotify.later')}
          </Button>
          <Button onClick={onConfirm} disabled={loading}>
            {loading ? <Loader2 size={18} className="animate-spin mr-2" /> : <Send size={18} className="mr-2" />}
            {t('heats.scheduleNotify.confirm', { count: recipients })}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleNotifyDialog;
